import { useQuery } from "@tanstack/react-query";
import { get } from "#api";
import OrganizationGrid from "./organization_grid";

function Organization() {
  const query = useQuery({
    queryKey: ["users"],
    queryFn: async () => {
      const data = await get(`/user/view`);
      return data;
    },
  });
  return (
    <div className="p-4">
      <div className="text-xl font-semibold pb-4">Organization</div>
      <div className="">
        <OrganizationGrid users={query.data} />
      </div>
    </div>
  );
}
export default Organization;
